import fileSys from "../fileoprators/fileSystem";
export const getLanguages = () => {
  let langs = {};
  let files = fileSys.readDirectory(fileSys.getCfgPath("i18n"));
  for (let id in files) {
    let key = fileSys.getFileBaseName(files[id]);
    langs[key] = {
      langcfg: fileSys.readJsonFile(fileSys.combinePath(files[id], "lang.json")),
      timezone: fileSys.readJsonFile(fileSys.combinePath(files[id], "timezone.json")),
      patientcfg: fileSys.readJsonFile(fileSys.combinePath(files[id], "patientconfig.json"))
    };
  }
  return langs;
};



// WEBPACK FOOTER //
// ./src/settings/language.js